export default {



    encodeQuery: (query) => {
        if(query.startDate)
            query.startDate = query.startDate.toString(); 
        
        if(query.endDate)
            query.endDate = query.endDate.toString();

        let input = JSON.stringify(query);
        var cleanParams = "";
        for (var i = 0; i < input.length; i++) {
            if (input.charCodeAt(i) <= 127) {
                cleanParams += input.charAt(i);
            }
        }
            
        let filterString = btoa(cleanParams);
        let url = new URL(window.location.href);
        let params = new window.URLSearchParams(window.location.search);
        params.set('filters', filterString);

        url.search = params;
        url = url.toString();
        window.history.replaceState({url: url}, null, url);
    },
    decodeQuery: () => {
        let url = new URL(window.location.href);
        let params = new window.URLSearchParams(window.location.search);
        let filterQuery = params.get('filters');
        let query = null;
        if(filterQuery) 
        {
            filterQuery = decodeURI(filterQuery);
            query = JSON.parse(atob(filterQuery));
            if(query.startDate)
                query.startDate = new Date(query.startDate);

            if(query.endDate)
                query.endDate = new Date(query.endDate);
        }
            
        return query;
    }
}